import { render, staticRenderFns } from "./ServiceBanner.vue?vue&type=template&id=dc213f8c&scoped=true&"
import script from "./ServiceBanner.vue?vue&type=script&lang=js&"
export * from "./ServiceBanner.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBanner.vue?vue&type=style&index=0&id=dc213f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc213f8c",
  null
  
)

export default component.exports